import { render, staticRenderFns } from "./SalutationSelect.vue?vue&type=template&id=0e49b1a3&"
import script from "./SalutationSelect.vue?vue&type=script&lang=js&"
export * from "./SalutationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/83/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e49b1a3')) {
      api.createRecord('0e49b1a3', component.options)
    } else {
      api.reload('0e49b1a3', component.options)
    }
    module.hot.accept("./SalutationSelect.vue?vue&type=template&id=0e49b1a3&", function () {
      api.rerender('0e49b1a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/SalutationSelect.vue"
export default component.exports